const MERCHANT2_API_URL = process.env.VUE_APP_MERCHANT2_API_URL + "/";
//const MERCHANT3_API_URL = process.env.VUE_APP_API_MOCK_URL + "/merchant/v3/"; //Don't check in....mock url

const MERCHANT3_API_URL = process.env.VUE_APP_MERCHANT3_API_URL + "/";

export const authenticationApiUrls = {
  ACTION_LOG: `${MERCHANT3_API_URL}actions/action-log`,
  EVENT_LOG: `${MERCHANT3_API_URL}actions/event-log`,
  CLERK_LIST: `${MERCHANT3_API_URL}clerks`,
  CONTRACT: `${MERCHANT2_API_URL}contracts`,
  CREATE_CLERK: `${MERCHANT3_API_URL}clerks`,
  DIRECT_TO_CUSTOMER_LOGIN: `${MERCHANT3_API_URL}actions/direct-to-customer/login`,
  FIND_CLERK: `${MERCHANT3_API_URL}actions/lookup-clerk`,
  GET_CLERK: `${MERCHANT3_API_URL}clerk`,
  LOGIN_CLERK: `${MERCHANT3_API_URL}actions/login-clerk`,
  GET_CLERK_AUTH_IDENTITY: `${MERCHANT3_API_URL}face-login/identity-session`,
  INCODE_AUTH_VERIFY: `${MERCHANT3_API_URL}face-login/selfie`,
  QR_CODE_LOGIN_STATUS: `${MERCHANT3_API_URL}qr-code-login/status`,
  CLERK_AUTH_ATTEMPT_STATUS: `${MERCHANT3_API_URL}face-login/status`,
  FACE_LOGIN_HEALTH_STATUS: `${MERCHANT3_API_URL}face-login/health`,
  QR_CODE_LOGIN_SESSION_STATUS: `${MERCHANT3_API_URL}qr-code-login/session/status`,
  QR_CODE_LOGIN_CS_REVIEW_STATUS: `${MERCHANT3_API_URL}qr-code-login/session/cs-review`,
  CREATE_QR_CODE_LOGIN_SESSION: `${MERCHANT3_API_URL}qr-code-login/session`,
  LOGIN_MERCHANT: `${MERCHANT3_API_URL}actions/login-merchant`,
  LOGIN_MERCHANT_BY_NAME: `${MERCHANT3_API_URL}actions/login-merchant-by-name`,
  LOGIN_PERSON_AS_CLERK: `${MERCHANT3_API_URL}actions/login-person-as-clerk`,
  MERCHANT_SING_IN: `${MERCHANT2_API_URL}login`,
  RECREATE_MERCHANT_PASSWORD: `${MERCHANT3_API_URL}actions/recreate-merchant-password`,
  REQUEST_CLERK_PIN_RESET: `${MERCHANT3_API_URL}actions/request-clerk-pin-reset`,
  REQUEST_MERCHANT_PASSWORD_RESET_CODE: `${MERCHANT3_API_URL}actions/request-merchant-password-reset`,
  LOGIN_KIOSK: `${MERCHANT3_API_URL}actions/login-kiosk`,
  BUILD_CLERK_CHATBOT_JWT: `${MERCHANT3_API_URL}actions/sunshine-jwt`,
};

export const MERCHANT_V3_API_URLS = (tag?: string): Record<string, string> => {
  return {
    ACCEPT_PRIVACY_POLICIES: `${MERCHANT3_API_URL}actions/accept-privacy`,
    UTILS_VALIDATE_PHONE_NUMBER: `${MERCHANT3_API_URL}actions/utils/validate-phone-number`,
    ACCEPT_TERMS: `${MERCHANT3_API_URL}actions/accept-terms`,
    ACCESS_KEY: `${MERCHANT3_API_URL}carts/${tag}/access-key`,
    ACTIVATE_DEVICE: `${MERCHANT3_API_URL}actions/activate-device`,
    ACTIVATE_DEVICE_REPAIR: `${MERCHANT3_API_URL}device-repair/activate`,
    ADD_ONS: `${MERCHANT3_API_URL}carts/${tag}/add-ons`,
    ADD_ONS_ELIGIBILITY: `${MERCHANT3_API_URL}carts/${tag}/add-ons/eligibility`,
    ADD_ONS_SELECT: `${MERCHANT3_API_URL}carts/${tag}/add-ons/select`,
    ADD_ONS_NOTIFICATION: `${MERCHANT3_API_URL}carts/${tag}/add-ons/notification`,
    ASK_CX_CALL: `${MERCHANT3_API_URL}carts/${tag}/ask-cx-call`,
    AUTHORIZE_CREDIT_CHECK: `${MERCHANT3_API_URL}carts/${tag}/authorize-credit-check`,
    AVAILABLE_OFFERS: `${MERCHANT3_API_URL}carts/${tag}/available-offers`,
    CALCULATE_OFFERS: `${MERCHANT3_API_URL}carts/${tag}/calculate-offers`,
    CANCEL_CART: `${MERCHANT3_API_URL}actions/cancel-cart`,
    CART: `${MERCHANT3_API_URL}cart`,
    CART_GEOLOCATION: `${MERCHANT3_API_URL}actions/geolocation`,
    CART_STATUS: `${MERCHANT3_API_URL}carts/${tag}/status`,
    CHECK_LOCK: `${MERCHANT3_API_URL}device-repair/check-lock`,
    CLAIM_DEVICE: `${MERCHANT3_API_URL}actions/claim-device`,
    CLERK_REGISTRATION_TAG: `${MERCHANT3_API_URL}clerk/registration-tag`,
    COLLECT_PAYMENT: `${MERCHANT3_API_URL}payments`,
    CREATE_CART: `${MERCHANT3_API_URL}carts`,
    CREATE_CART_MILESTONE: `${MERCHANT3_API_URL}carts/${tag}/milestones`,
    CREATE_CUSTOMER: `${MERCHANT3_API_URL}actions/create-customer`,
    CREATE_BANK_PROPOSAL: `${MERCHANT3_API_URL}carts/${tag}/bank-proposal`,
    CREATE_MARKETING_EVENT: `${MERCHANT3_API_URL}marketing/events`,
    CREDIT_CHECK_PERMISSION: `${MERCHANT3_API_URL}documents/credit-check`,
    CUSTOMER: `${MERCHANT3_API_URL}customers/${tag}`,
    DEVICE_PROVISIONING: `${MERCHANT3_API_URL}devices/provisioning-info`,
    DEVICE_REPAIR_UPLOAD_IMAGE: `${MERCHANT3_API_URL}device-repair/upload-image`,
    FEEDBACK: `${MERCHANT3_API_URL}actions/submit-feedback`,
    FINANCE_ORDER_RECEIPT: `${MERCHANT3_API_URL}finance-orders/receipt`,
    GENERATE_ONE_TIME_PASSWORD: `${MERCHANT3_API_URL}one-time-password/${tag}/generate`,
    GET_ACTIVATION_METHOD: `${MERCHANT3_API_URL}devices/activation-method/${tag}`,
    GET_CONTRACT: `${MERCHANT3_API_URL}carts/${tag}/contract`,
    GET_COUNTRY_LANGUAGES: `${MERCHANT3_API_URL}languages`,
    GET_DATA: `${MERCHANT3_API_URL}device-repair/get-data/${tag}`,
    GET_DOWNPAYMENT_STATUS: `${MERCHANT3_API_URL}actions/get-customer-down-payment-status`,
    GET_FRAUD_CHECK: `${MERCHANT3_API_URL}carts/${tag}/fraud-check`,
    GET_IMAGES: `${MERCHANT3_API_URL}images`,
    GET_INCODE_LIVENESS: `${MERCHANT3_API_URL}carts/${tag}/incode-liveness`,
    GET_MERCHANT: `${MERCHANT3_API_URL}merchant`,
    CLERK_REGISTRATION_REQUEST: `${MERCHANT3_API_URL}clerk/request-account`,
    GET_NEXT_ROUTE: `${MERCHANT3_API_URL}carts/${tag}/next-route`,
    GET_OFFER_SUMMARY: `${MERCHANT3_API_URL}carts/${tag}/offer-summary`,
    GET_OTP_STATUS: `${MERCHANT3_API_URL}one-time-password/${tag}/status`,
    GET_PERSON_INFO: `${MERCHANT3_API_URL}persons/person-info`,
    STORE_PERSON_ATTRIBUTES: `${MERCHANT3_API_URL}persons/person-attributes`,
    IDENTIFY_LEAD: `${MERCHANT3_API_URL}actions/customers/identify-lead`,
    GET_PERSON_ATTRIBUTES: `${MERCHANT3_API_URL}carts/${tag}/person-attributes`,
    GET_PERSON_FRAUD_ASSESSMENT: `${MERCHANT3_API_URL}carts/${tag}/persons-fraud-assessment`,
    GET_PHONE_SELFIE_STATUS: `${MERCHANT3_API_URL}carts/${tag}/phone-selfie-status`,
    GET_RECOMMENDED_DEVICES: `${MERCHANT3_API_URL}carts/${tag}/recommended-devices`,
    GET_VOUCHER_CODES: `${MERCHANT3_API_URL}carts/${tag}/voucherCodes`,
    HEARTBEAT_CART: `${MERCHANT3_API_URL}carts/${tag}/heartbeat`,
    IDENTIFICATION_UPLOAD: `${MERCHANT3_API_URL}carts/${tag}/image`,
    INCONSOLE_FEATURED_MESSAGE: `${MERCHANT3_API_URL}in-console-messages/featured`,
    INCONSOLE_MESSAGES: `${MERCHANT3_API_URL}in-console-messages/`,
    IS_CS_AVAILABLE: `${MERCHANT3_API_URL}carts/${tag}/is-cs-available`,
    LOOKUP_POSTAL_CODE_LOCATION: `${MERCHANT3_API_URL}address/lookup`,
    IMAGE_TRANSCRIBE: `${MERCHANT3_API_URL}actions/transcribe-id`,
    INCODE_IMPORT: `${MERCHANT3_API_URL}incode/${tag}/import`,
    INCODE_ONBOARD: `${MERCHANT3_API_URL}incode/${tag}/onboard`,
    INCODE_STATUS: `${MERCHANT3_API_URL}incode/${tag}/status`,
    INCODE_STATUS_FRONT: `${MERCHANT3_API_URL}incode/${tag}/status-front`,
    INCODE_STATUS_FRONT_COMPLETED: `${MERCHANT3_API_URL}incode/${tag}/status-front-completed`,
    INCODE_UPDATE_UUID: `${MERCHANT3_API_URL}incode/${tag}/update-uuid`,
    INITIATE_DOWNPAYMENT: `${MERCHANT3_API_URL}actions/create-down-payment`,
    IS_USER_APPROVED: `${MERCHANT3_API_URL}carts/${tag}/is-user-approved`,
    KG_ENROLL: `${MERCHANT3_API_URL}actions/kg-enroll`,
    LOOKUP_PERSON: `${MERCHANT3_API_URL}actions/lookup-person`,
    ATTEMPT_KYC: `${MERCHANT3_API_URL}actions/attempt-kyc`,
    MANUFACTURER: `${MERCHANT3_API_URL}carts/${tag}/available-manufacturers`,
    PRE_INSTALL_GET_QR_CODE: `${MERCHANT3_API_URL}pre-install/get-qrcode`,
    PRE_REGISTRATION_MANUFACTURER: `${MERCHANT3_API_URL}carts/${tag}/preRegistration/device-brands`,
    PRE_REGISTRATION_DEVICES: `${MERCHANT3_API_URL}carts/${tag}/preRegistration/devices`,
    PRE_REGISTRATION_PAYMENT_TERMS: `${MERCHANT3_API_URL}carts/${tag}/preRegistration/payment-terms`,
    MERCHANT_LATEST_RECEIPTS: `${MERCHANT3_API_URL}merchant/latest-receipts`,
    MERCHANT_SUPPORTED_MODELS: `${MERCHANT3_API_URL}merchant/supported-models`,
    OFFERS: `${MERCHANT3_API_URL}carts/${tag}/offers`,
    ORDER: `${MERCHANT3_API_URL}carts/${tag}`,
    OPEN_REPAIRS: `${MERCHANT3_API_URL}device-repair/get-list`,
    OPENPAY_CARD_CHARGE_FOR_DP: `${MERCHANT3_API_URL}carts/${tag}/openpay-card-charge-for-downpayment`,
    OPENPAY_FORM_INITIALIZER: `${MERCHANT3_API_URL}carts/${tag}/openpay-form-initializer`,
    PAYMENTS_RECEIPT: `${MERCHANT3_API_URL}payments/${tag}/receipt`,
    PAYMENT_INQUERY: `${MERCHANT3_API_URL}payments/lookup`,
    PRICING: `${MERCHANT3_API_URL}carts/${tag}/offers/pricing`,
    PRICING_GET_DEVICE_DETAILS: `${MERCHANT3_API_URL}pricing/device-details/${tag}`,
    QUICK_PERMISSION: `${MERCHANT3_API_URL}carts/${tag}/quick-permission`,
    REPAIR_HISTORY: `${MERCHANT3_API_URL}device-repair/history/${tag}`,
    SEARCH_REPAIR: `${MERCHANT3_API_URL}device-repair/search/${tag}`,
    SET_DEVICE_MODEL: `${MERCHANT3_API_URL}carts/${tag}/device-model`,
    SET_OFFER_DATA: `${MERCHANT3_API_URL}carts/${tag}/offer-data`,
    SET_PRICE: `${MERCHANT3_API_URL}carts/${tag}/price`,
    SET_DOWN_PAYMENT: `${MERCHANT3_API_URL}carts/${tag}/down-payment`,
    PRIVACY_POLICY: `${MERCHANT3_API_URL}documents/privacy`,
    RECEIPT: `${MERCHANT3_API_URL}carts/${tag}/receipt`,
    RECORD_ADDRESS: `${MERCHANT3_API_URL}carts/${tag}/address`,
    RECORD_EMAIL: `${MERCHANT3_API_URL}carts/${tag}/email`,
    RECORD_PHONE: `${MERCHANT3_API_URL}carts/${tag}/phone`,
    RELEASE_TRUSTONIC_DEVICE: `${MERCHANT3_API_URL}devices/trustonic/release-device`,
    REPLACEMENT_DEVICE: `${MERCHANT3_API_URL}device-repair/replacement-devices`,
    REQUEST_CONTRACT_PIN: `${MERCHANT3_API_URL}actions/contract-pin`,
    RESET_VALIDATION: `${MERCHANT3_API_URL}customers/${tag}/reset-validation`,
    SAVE_FACEBOOK_DATA: `${MERCHANT3_API_URL}carts/${tag}/facebook`,
    SET_DEVICE_PHONE: `${MERCHANT3_API_URL}carts/${tag}/set-device-phone`,
    SET_DEVICE_IMEI: `${MERCHANT3_API_URL}carts/${tag}/set-device-imei`,
    SET_DEVICE: `${MERCHANT3_API_URL}carts/${tag}/set-device`,
    SIGN_CONTRACT: `${MERCHANT3_API_URL}actions/sign-contract`,
    SIGN_CREDIT_CHECK: `${MERCHANT3_API_URL}carts/${tag}/sign-credit-check`,
    SUBMIT_CART: `${MERCHANT3_API_URL}actions/submit-cart`,
    SUBMIT_OFFERS: `${MERCHANT3_API_URL}carts/${tag}/months`,
    SUSPICIOUS_ACTIVITY: `${MERCHANT3_API_URL}actions/ssaa`,
    SWAP: `${MERCHANT3_API_URL}device-repair/swap`,
    TERMS_AND_CONDITIONS: `${MERCHANT3_API_URL}documents/terms`,
    UPDATE_PAGE: `${MERCHANT3_API_URL}carts/${tag}/page`,
    VERIFY_PHONE: `${MERCHANT3_API_URL}carts/${tag}/phone-verify`,
    WELCOME_CALL_STATUS: `${MERCHANT3_API_URL}carts/${tag}/welcome-call/status`,
    WRITE_REPAIR_LOG: `${MERCHANT3_API_URL}device-repair/log`,
    GENERATE_VIRTUAL_VOUCHER: `${MERCHANT3_API_URL}virtual-voucher/create/${tag}`,
    CONFIGURATIONS: `${MERCHANT3_API_URL}carts/${tag}/configurations`,
    FETCH_VIRTUAL_VOUCHER_STATUS: `${MERCHANT3_API_URL}virtual-voucher/${tag}/status`,
    STORE_USER_NOTE: `${MERCHANT3_API_URL}actions/notes`,
    CART_VERIFICATION: `${MERCHANT3_API_URL}carts/${tag}/document-files/verify`,
    CART_DOCUMENT_FILE_UPLOAD: `${MERCHANT3_API_URL}carts/${tag}/document-files`,
    LOOKUP_PERSON_ID: `${MERCHANT3_API_URL}actions/lookup-person-id-number`,
    ATTEMPT_KYC_ID_NUMBER: `${MERCHANT3_API_URL}actions/attempt-kyc-id-number`,
  };
};

export const SPEED_MONEY_API_URLS = (): Record<string, string> => {
  return {
    GET_PAYMENT_INFORMATION: `${MERCHANT3_API_URL}speed-money/payment-information`,
    REGISTER: `${MERCHANT3_API_URL}speed-money/register`,
    UPDATE_PAYMENT_INFORMATION: `${MERCHANT3_API_URL}speed-money/update-payment-information`,
    SEARCH_EXISTING_REGISTRATION: `${MERCHANT3_API_URL}speed-money/search-existing-registration`,
    MIGRATE_PAYMENT_INFORMATION: `${MERCHANT3_API_URL}speed-money/migrate-payment-information`,
  };
};

export const SELF_ONBOARDING_API_URLS = (): Record<string, string> => {
  return {
    GET_VALID_CART: `${MERCHANT3_API_URL}self-onboarding/get-valid-cart`,
  };
};

export const E_COMMERCE_API_URLS = (): Record<string, string> => {
  return {
    AUTH_M3: `${MERCHANT3_API_URL}e-commerce/authM3`,
  };
};
